import { throttle } from 'lodash'
import { useStore } from '../../../models'
import { Platform } from 'react-native'

export const useAVOptions = () => {
  const {
    communication,
    communication: { isLocalUserMuted, isLocalUserVideoHidden, isLocalUserJoined },
    session
  } = useStore()

  const isVideoOff = isLocalUserJoined && isLocalUserVideoHidden
  const isAudiOff = isLocalUserJoined && isLocalUserMuted

  const muteCall = throttle(async () => {
    const playerUserId = session.user?._id
    const userAVCallStatus = communication.usersAVCallStatus
    const myPlayerStatus = userAVCallStatus.filter((user) => user.userId === playerUserId)
    if (myPlayerStatus.length > 0) {
      communication.setPlayerVideoCallStatus(
        myPlayerStatus[0].isPlayerOnVideoCall,
        myPlayerStatus[0].isPlayerOnAudioCall,
        true
      )
      await communication.muteVideoCall()
    }
  }, 500)

  const unMuteCall = throttle(async () => {
    const playerUserId = session.user?._id
    const userAVCallStatus = communication.usersAVCallStatus
    const myPlayerStatus = userAVCallStatus.filter((user) => user.userId === playerUserId)

    if (Platform.OS === 'web') {
      communication.startAudioStream()
    }

    if (myPlayerStatus.length > 0) {
      communication.setPlayerVideoCallStatus(
        myPlayerStatus[0].isPlayerOnVideoCall,
        myPlayerStatus[0].isPlayerOnAudioCall,
        false
      )

      await communication.unMuteVideoCall()
    }
  }, 500)

  const hideVideo = throttle(async () => {
    communication.setPlayerVideoCallStatus(false, true, communication.isLocalUserMuted)
    await communication.pauseVideoStream()
  }, 500)

  const showVideo = throttle(async () => {
    if (Platform.OS !== 'web') {
      communication.rtcEngine?.enableVideo()
    } else {
      communication.startVideoStream()
    }

    communication.setPlayerVideoCallStatus(true, true, communication.isLocalUserMuted)
    await communication.resumeVideoStream()
  }, 500)

  return {
    isVideoOff,
    isAudiOff,
    muteCall,
    unMuteCall,
    hideVideo,
    showVideo
  }
}
